"use client";

import { motion } from "framer-motion";

/** Animated numeric counter for live token and update counts. */
export function AnimatedCounter({ value }: { value: number }) {
  return (
    <span className="relative inline-flex h-5 min-w-[2ch] items-center justify-end overflow-hidden tabular-nums">
      <motion.span
        key={value}
        initial={{ y: 6, opacity: 0.65 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.14, ease: "easeOut" }}
      >
        {value.toLocaleString()}
      </motion.span>
    </span>
  );
}
